import { action, makeAutoObservable, observable } from "mobx";
import { BenefitsModel } from "./BenefitsModel";

export class AddUpdateBenefitStore {
  @observable public upsertBenefit: BenefitsModel;
  constructor() {
    this.upsertBenefit = new BenefitsModel();
    makeAutoObservable(this);
  }

  @action
  update(upsertBenefit: BenefitsModel) {
    this.upsertBenefit = new BenefitsModel(upsertBenefit);
  }

  @action
  validate(): boolean {
    const isValid = this.upsertBenefit.validate();
    this.update(this.upsertBenefit);
    return isValid;
  }
}
